import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _LIST_STAFFS = async (searchData = false) => {
  let url = ServiceUrl.MOB.LIST_STAFFS;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_TASK_PRIORITIES = async (searchData = false) => {
  let url = ServiceUrl.MOB.LIST_TASK_PRIORITIES;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_TASK_CATEGORIES = async (searchData = false) => {
  let url = ServiceUrl.MOB.LIST_TASK_CATEGORY;
  return callApi(url, "post", searchData && searchData);
};

export const _ADD_TASK = async (searchData = false) => {
  let url = ServiceUrl.MOB.ADD_TASK;
  return callApi(url, "post", searchData && searchData);
};
export const _EDIT_TASK = async (searchData = false) => {
  let url = ServiceUrl.MOB.EDIT_TASK;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_TASKS = async (searchData = false) => {
  let url = ServiceUrl.MOB.LIST_TASKS;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_TASK_LOG = async (searchData = false) => {
  let url = ServiceUrl.MOB.LIST_TASK_LOG;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_TASK_RESPONSE = async (searchData = false) => {
  let url = ServiceUrl.MOB.UPDATE_TASK_RESPONSE;
  return callApi(url, "post", searchData && searchData);
};

export const _ADD_CATEGORY = async (searchData = false) => {
  let url = ServiceUrl.MOB.ADD_CATEGORY;
  return callApi(url, "post", searchData && searchData);
};

export const _EDIT_CATEGORY = async (searchData = false) => {
  let url = ServiceUrl.MOB.EDIT_CATEGORY;
  return callApi(url, "post", searchData && searchData);
};
